<div>
	<p-treeTable [value]="treeData" [autoLayout]="true" styleClass="p-treetable-sm">
		<ng-template pTemplate="caption">
			Draft Notes
			<span *ngIf="loadingDraftNotes" class="pi pi-spin pi-spinner p-ml-1"></span>
		</ng-template>

		<ng-template pTemplate="body" let-rowNode let-rowData="rowData">
			<tr>
				<td>
					<div class="p-d-flex p-ai-center">
						<p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
						{{rowData.keyValues}}
						<p-badge *ngIf="rowNode.parent && rowNode.node.children?.length" styleClass="p-ml-3" [value]="rowNode.node.children.length"></p-badge>
					</div>
				</td>

				<td>
					<ng-container *ngIf="rowData.note">
						<div *ngFor="let user of rowData.coCreators">
							{{user.user.firstName}} {{user.user.lastName}}
						</div>
					</ng-container>
				</td>

				<td>
					<ng-container *ngIf="rowData.note">
						{{rowData.created | date:'MM/dd/yyyy HH:mm'}}
					</ng-container>
				</td>

				<td class="p-text-right p-text-nowrap">
					<ng-container *ngIf="rowData.note">
						<button class="p-button-primary" (click)="editNote(rowData.note)" pTooltip="Edit Note"
							tooltipPosition="top" pButton icon="pi pi-pencil">
						</button>

						<button (click)="displayDeleteConfirm(rowData.note, $event, rowData.logIx, rowData.templateIx, rowData.noteIx)"
							class="p-button-danger" pTooltip="Delete Note" [tooltipPosition]="deleteButtonTooltipPosition" pButton icon="pi pi-trash">
						</button>

						<p-confirmPopup [key]="rowData.note.id.toString()"></p-confirmPopup>
					</ng-container>
				</td>
			</tr>
		</ng-template>
	</p-treeTable>
</div>